import { Component, OnInit } from '@angular/core';
import { ControllerService } from '../shared/services/controller.service';

@Component({
    selector: 'app-ender',
    templateUrl: './ender.component.html',
    styleUrls: ['./ender.component.scss'],
    standalone: false
})
export class EnderComponent implements OnInit {

  constructor(private controller: ControllerService) { }

  ngOnInit() {

    this.controller.goToLibrary()
  }

}
